export default __webpack_public_path__ + "static/media/0x91c89a94567980f0e9723b487b0bed586ee96aa7.c8a6afdc.webp";